import {Component, OnInit, ViewChild} from '@angular/core';
import {BundeslandFilterService} from '../../service/bundeslandFilter/bundesland-filter.service';
import {MatDialogRef} from '@angular/material/dialog';
import {Bundesland} from '../../model/component/bundesland';
import {MatChipList} from '@angular/material/chips';

@Component({
  selector: 'app-pop-up-filter-dialog',
  templateUrl: './pop-up-filter-dialog.component.html',
  styleUrls: ['./pop-up-filter-dialog.component.css']
})
export class PopUpFilterDialogComponent implements OnInit {

  @ViewChild('matChipList') matChipList: MatChipList;

  constructor(public bundeslandFilterService: BundeslandFilterService,
              public dialogRef: MatDialogRef<PopUpFilterDialogComponent>) {
  }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }

  /**
   * Hier muss ein kleiner Workaround angewendet werden,
   * da Europa & Deutschland NUR einzelnd und nicht kombinierbar angewendent werden können
   * Wenn Deutschland oder Europa ausgewählt werden, müssen die jeweils anderen Option abgewählt werden
   * @param option Bundesland
   */
  selectOption(option: Bundesland) {
    if (option.name === 'Europa' || option.name === 'Deutschland') {
      this.matChipList.chips.forEach(item => item.selected = false);
      this.bundeslandFilterService.deselectAll();
    } else {
      this.bundeslandFilterService.filter.forEach(l => {
        if (l.name === 'Deutschland' || l.name === 'Europa') {
          l.isSelected = false;
        }
      });
    }

    option.isSelected ? option.isSelected = false : option.isSelected = true;
  }

  setFilter() {
    this.close();
    this.bundeslandFilterService.updateFilter();

  }
}
